let fallback = {};
const sessionKeys = new Set(['axis', 'embed']); // ключи, которые нужно хранить в session

function getBackend(key) {
    if (typeof window === 'undefined') return { getItem: () => null, setItem: () => {}, removeItem: () => {} };

    try {
        if (sessionKeys.has(key)) return sessionStorage;

        return localStorage;
    } catch (e) {
        return fallback;
    }
}

export default class {
    static getItem(key) {
        const backend = getBackend(key);

        try {
            return backend.getItem(key);
        } catch (e) {
            return fallback[key] ?? null;
        }
    }

    static setItem(key, value) {
        const backend = getBackend(key);

        try {
            backend.setItem(key, value);
        } catch (e) {
            fallback[key] = value;
        }
    }

    static removeItem(key) {
        const backend = getBackend(key);

        try {
            backend.removeItem(key);
        } catch (e) {
            delete fallback[key];
        }
    }

    static getItemAndRemove(key) {
        let val = this.getItem(key);

        this.removeItem(key);

        return val;
    }

    static clear() {
        try {
            localStorage.clear();
            sessionStorage.clear();
        } catch (e) {
            fallback = {};
        }
    }
}
